const SearchInputField = (props) => {
  const { name, label, type, tabIndex, onChange } = props;

  return (
    <>
      <div className='input-group'>
        <span className='input-group-text text-primary'>{label}</span>
        <input
          tabIndex={tabIndex}
          type={type || "text"}
          className='form-control'
          aria-label={label}
          placeholder={label}
          onChange={onChange}
          aria-describedby={label}
          name={name}
        />
      </div>
    </>
  );
};
export default SearchInputField;
